/**
 * 策划中心-协同指挥-左侧导航
 * 2017-11-10
 * Bai.Zhiming
 */
"use strict";
angular.module("commandLeftModule", []).
directive("commandLeft", ["$state", "trsHttpService", "$q", "$timeout", "commandService", "$filter", "repSummService", function($state, trsHttpService, $q, $timeout, commandService, $filter, repSummService) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./planningCenter/command/left/left_tpl.html",
        scope: {
            selected: "=",
            accessAuthority: "="
        },
        link: function(scope, $elem, $attrs) {

            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    expanded: false,
                    expandedLeve2: ""
                };
                scope.data = {
                    reportSummaryGroups: [],
                    topicsSummaryGroups: []
                };
                autoLocation()
            }

            function autoLocation() {
                scope.$watch("selected", (newV, oldV) => {
                    if (newV === "command") {
                        scope.status.expanded = true;
                        let routerName = $state.current.name;
                        let routerArray = routerName.split(".");
                        if ($state.current.name != "front.plan.command") {
                            scope.status.expandedLeve2 = routerArray[3];
                            /*scope.status.selectedLeve3 = routerArray[3] + "." + routerArray[4];*/
                            if (routerArray[3] === "managegroups") {
                                scope.$root.narrowNavigation = true;
                            } else if (routerArray[3] === "reportsummary") {
                                scope.$root.narrowNavigation = false;
                                scope.status.groupId = $state.params.groupid;
                                getReportSummaryGroups();
                            } else if (routerArray[3] === "topicssummary") {
                                scope.$root.narrowNavigation = false;
                                scope.status.groupId = $state.params.groupid;
                                getTopicsSummaryGroups();
                            }else if(routerArray[3] === "groupassignment") {
                                scope.$root.narrowNavigation = false;
                                scope.status.groupId = $state.params.groupid;
                                getReportSummaryGroups();
                            }
                        }
                    } else {
                        scope.status.expandedLeve2 = "";
                    }
                });
            }
            /**
             * [expandReportSummaryGroups description] 展开报题分组
             * @param {[type]} [$event] [description] 点击事件
             * @return {[type]} [description]
             */
            scope.expandReportSummaryGroups = function($event) {
                getReportSummaryGroups().then(() => {
                    scope.expandLeve2('reportsummary', $event);
                });
            };
            /**
             * [expandTopicsSummaryGroups description] 展开选题分组列表
             * @param {[type]} [$event] [description] 点击事件
             * @return {[type]} [description]
             */
            scope.expandTopicsSummaryGroups = function($event) {
                getTopicsSummaryGroups().then(() => {
                    scope.expandLeve2('topicssummary', $event);
                });
            };
            /**
             * [getReportSummaryGroups description] 获取报题分组
             * @return {[type]} [description]
             */
            function getReportSummaryGroups() {
                let deffer = $q.defer();
                if (scope.data.reportSummaryGroups.length == 0) {
                    let params = {
                        methodname: "queryOwnerGroup",
                        serviceid: "mlf_newreport"
                    };
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(data => {
                        scope.data.reportSummaryGroups = data;
                        deffer.resolve();
                    });
                } else {
                    deffer.resolve();
                }
                return deffer.promise;
            }
            /**
             * [getTopicsSummaryGroups description] 获取选题列表
             * @return {[type]} [description]
             */
            function getTopicsSummaryGroups() {
                let deffer = $q.defer();
                if (scope.data.topicsSummaryGroups.length == 0) {
                    let params = {
                        methodname: "queryFeaturedGroup",
                        serviceid: "mlf_newreport",
                        StartTime: $filter("date")(new Date(), "yyyy-MM-dd"),
                        EndTime: getNextMonthDate(),
                        IsPass: 1
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(data => {
                        scope.data.topicsSummaryGroups = data;
                        deffer.resolve();
                    });
                } else {
                    deffer.resolve();
                }
                return deffer.promise;
            }
            /**
             * [getNextMonthDate description] 获取下个月的今天
             * @return {[type]} [description]
             */
            function getNextMonthDate() {
                let theDay = new Date();
                let month = theDay.getMonth();
                theDay.setMonth(month + 1);
                return $filter("date")(theDay, "yyyy-MM-dd");
            }
            /**
             * [expandLeve2 description] 展开二级
             * @param  {[type]} type [description] 类型名称
             * @return {[type]}      [description]
             */
            scope.expandLeve2 = function(type, $event) {
                scope.status.expandedLeve2 = type;
                $timeout(() => {
                    $($event.currentTarget).next("ul").find("a")[0].click();
                    scope.$root.narrowNavigation = false;
                });
            };
            /**
             * [selectLeve3 description] 选中三级
             * @param  {[type]} routerNamePart [description] 路由名称
             * @return {[type]}            [description]
             */
            scope.selectLeve3 = function(routerNamePart, item) {
                let routerName = "front.plan.command." + routerNamePart;
                let params = {
                    groupid: item.GROUPID || item.NEWGROUPID,
                    groupname: item.GNAME,
                    starttime: $filter("date")(new Date, "yyyy-MM-dd"),
                    endtime: getNextMonthDate()
                };
                $state.go(routerName, params, { reload: routerName });
                scope.status.selectedLeve3 = routerNamePart;
                scope.status.groupId = item.GROUPID || item.NEWGROUPID;
                if (scope.selected !== "command") {
                    $timeout(() => {
                        scope.selected = "command";
                    }, 500);
                }
            };
            /**
             * [selectLeve2 description] 选中二级
             * @param  {[type]} routerNamePart [description] 路由名称
             * @return {[type]}            [description]
             */
            scope.selectLeve2 = function(routerNamePart) {
                scope.status.expandedLeve2 = routerNamePart;
                $state.go("front.plan.command." + routerNamePart, "", { reload: "front.plan.command." + routerNamePart });
                scope.$root.narrowNavigation = true;
                if (scope.selected !== "command") {
                    $timeout(() => {
                        scope.selected = "command";
                    }, 500);
                }
            };

        }
    };
}]);